import { format, parseISO } from 'date-fns'
import {formatForTimezone} from '../../modules/utilities/dates.js'
import { displayNumber } from '../../modules/utilities/numbers.js'
import { displayReportResults } from '../../modules/ui.js'

const shipmentsTemplate = document.getElementById('tmpl-report-shipments')

export default class MTShipmentsReport extends HTMLElement {
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.shadowRoot.appendChild(shipmentsTemplate.content.cloneNode(true))
        console.info({ tableTemplate: shipmentsTemplate })

        this.headElement = this.shadowRoot.querySelector('.js-summary-head')
        this.averageWeightElement = this.shadowRoot.querySelector(
            '.js-summary-average-weight'
        )
        this.salesCWTElement = this.shadowRoot.querySelector(
            '.js-summary-sales-cwt'
        )
        this.totalNetSaleElement = this.shadowRoot.querySelector(
            '.js-summary-total-net-sale'
        )
        this.startDateElement = this.shadowRoot.querySelector(
            '.js-summary-start'
        )
        this.errorElement = this.shadowRoot.querySelector('#js-error-container')
        this.endDateElement = this.shadowRoot.querySelector('.js-summary-end')
        this.printElement = this.shadowRoot.querySelector('#js-print-report')
        this.printElement.addEventListener(
            'click',
            () => {
                this.dispatchEvent(new CustomEvent('printReportEvent'))
            },
            false
        )
    }

    set data(value) {
        const startDate = document.querySelector('#startDate').value
        const endDate = document.querySelector('#endDate').value

        const sd = parseISO(startDate)
        const ed = parseISO(endDate)

        this._data = value
        this._results = value.reportData
        this._summary = {
            head: value.head,
            averageWeight: value.averageWeight,
            totalNetSale: value.totalNetSale,
            salesCWT: value.salesCWT,
            startDate: new Date(sd),
            endDate: new Date(ed),
        }

        if (this._data.hasError) {
            this.displayError()
        } else {
            this.displaySummary()
            displayReportResults(this, '#js-shipments-results-container')
        }
    }

    displayError() {
        console.log(this._data.errorMessage)
        this.errorElement.innerText = this._data.errorMessage
    }

    displaySummary() {
        this.startDateElement.innerText = format(
            this._summary.startDate,
            'MM/dd/yyyy'
        )
        this.endDateElement.innerText = format(
            this._summary.endDate,
            'MM/dd/yyyy'
        )

        this.headElement.innerText = displayNumber(this._summary.head, 1)
        this.averageWeightElement.innerText = displayNumber(
            this._summary.averageWeight,
            0
        )
        this.salesCWTElement.innerText = displayNumber(
            this._summary.salesCWT,
            2
        )
        this.totalNetSaleElement.innerText = displayNumber(
            this._summary.totalNetSale,
            2
        )
    }

    locationResultsRow(props) {
        return `
            <tr class="report-data--row">
                <td class="center date">
                    ${formatForTimezone(props.SHIP_DATE, 'MM/dd/yy')}
                </td>
                <td class="left lot">
                    ${props.LOT ?? ''}
                </td>
                <td class="left pen">
                    ${props.PEN ?? ''}
                </td>
                <td class="right ownership-percentage">
                    ${displayNumber(props.OWNRSHIP_PCT * 100, 2)}
                </td>
                <td class="right head">
                    ${displayNumber(props.SHIP_HEAD, 1)}
                </td>
                <td class="left sex">
                    ${props.SEX ?? ''}
                </td>
                <td class="right pay-weight--total">
                    ${displayNumber(props.TOTAL_CALC_PAY_WT, 0)}
                </td>
                <td class="right pay-weight--average">
                    ${displayNumber(props.TOTAL_AVG_CALC_PAY_WT, 0)}
                </td>
                <td class="right net-sales--total">
                    ${displayNumber(props.NET_SALES, 2)}
                </td>
                <td class="right net-sales--average">
                    ${displayNumber(props.NET_SALES_CWT, 2)}
                </td>
                <td class="classification">
                    ${props.CLASSIFICATION ?? ''}
                </td>
                <td class="sold-to">
                    ${props.SOLD_TO ?? ''}
                </td>
            </tr>
        `
    }

    calculateLocationTotals(a, l) {
        return {
            head: a.head + l.SHIP_HEAD,
            calculatedTotalPayWeight:
                a.calculatedTotalPayWeight + l.TOTAL_CALC_PAY_WT,
            totalNetSale: a.totalNetSale + l.NET_SALES,
        }
    }

    locationTotalsAccumulator() {
        return {
            head: 0,
            calculatedTotalPayWeight: 0,
            totalNetSale: 0,
        }
    }

    locationNoResultsTemplate(props) {
        return `
            <div class="mt-well mt-template-indent" data-location-id="${props.locationID}">
                <div class="mt-well--content">
                <h3 class="mt-report-title">${props.locationName}</h3>
                    <p>There are no results for ${props.locationName} during this timeframe.</p>
                </div>
            </div>
            `
    }

    locationResultsTemplate(props) {
        const total = props.data.reduce(
            this.calculateLocationTotals,
            this.locationTotalsAccumulator()
        )
        return `
            <div class="mt-well" data-location-id="${props.locationID}" data-collapsible-id="${props.locationID}" data-collapsed="false">
                <div class="mt-well--content">
                    <h3 class="mt-report-title">
						<svg id="collapse-${props.locationID}" data-collapsed="false" class="h-3 w-3 md:h-6 md:w-6" fill="var(--color-action)" viewBox="-150 -350 900 900" height="1.5rem" aria-hidden="true" style="cursor:pointer;">
			            	<path name="expand-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
			                <path name="collapse-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z" />
			            </svg>
						${props.locationName}
					</h3>
                    <div class="mt-table--container">
                    <table class="js-report--table mt-table">
                <thead class="mt-table--head">
                    <tr>
                        <th scope="col" class="center date collapsed-hidden">
                            Date
                        </th>
                        <th scope="col" class="left lot collapsed-hidden">
                            Lot
                        </th>
                        <th scope="col" class="left pen collapsed-hidden">
                            Pen
                        </th>
                        <th scope="col" class="right ownership-percentage collapsed-hidden">
                            <abbr title="Ownership Percentage">Owner%</abbr>
                        </th>
                        <th scope="col" class="right head">
                            Head
                        </th>
                        <th scope="col" class="left sex collapsed-hidden">
                            Sex
                        </th>
                        <th scope="col" class="right pay-weight--total">
                            <abbr title="Total Calculated Pay Weight">Total Calc Pay Wt</abbr>
                        </th>
                        <th scope="col" class="right pay-weight--average">
                            <abbr title="Average Calculated Pay Weight">Avg Calc Pay Wt</abbr>
                        </th>
                        <th scope="col" class="right net-sales--total">
                            Total Net Sale
                        </th>
                        <th scope="col" class="right net-sales--average">
                            Net Sale / CWT
                        </th>
                        <th scope="col" class="left classification collapsed-hidden">
                            Type
                        </th>
                        <th scope="col" class="left sold-to collapsed-hidden">
                            Sold To
                        </th>
                    </tr>
                </thead>
                <tbody>
                    ${props.data.map(this.locationResultsRow).join('')}
                </tbody>
                <tfoot>
                    <tr>
                        <th scope="row" class="total" colspan="4">Total</th>
                        <td class="footer-total">${displayNumber(
                            total.head,
                            1
                        )}</td>
                        <td>&nbsp;</td>
                        <td class="footer-total">${displayNumber(
                            total.calculatedTotalPayWeight,
                            0
                        )}</td>
                        <td class="footer-total">${displayNumber(
                            total.calculatedTotalPayWeight / total.head,
                            0
                        )}</td>
                        <td class="footer-total">
                            ${displayNumber(total.totalNetSale, 2)}
                        </td>
                        <td class="footer-total">${displayNumber(
                            (total.totalNetSale /
                                total.calculatedTotalPayWeight) *
                                100,
                            2
                        )}</td>
                        <td colspan="2">&nbsp;</td>
                    </tr>
                </tfoot>
                </table>
                </div>
    </div>
  </div>
        `
    }

    connectedCallback() {}

    render() {}
}

customElements.define('mt-shipments-report', MTShipmentsReport)
